
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ProdPreviewService {
  private readonly key = 'prodpreview';

  constructor() {
    this.initialize();
  }

  private initialize(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(this.key);

    if (paramValue !== null) {
      sessionStorage.setItem(this.key, paramValue === 'true' ? 'true' : 'false');
    }
  }

  public isProdPreview(): boolean {
    return sessionStorage.getItem(this.key) === 'true';
  }

  public clearProdPreview(): void {
    sessionStorage.removeItem(this.key);
  }
}
